class Heartbeat {

    /** Heartbeat.js
     * Calls the Player Heartbeat API every X seconds, which is used for Continue Watching.
     */
    constructor(options) {
        console.log('Simplestream::Heartbeat::Constructor()');

        // Validate options
        if(!options.videoElement) {
            console.error('Simplestream::Heartbeat: Missing videoElement');
            return;
        } else if(!options.companyId) {
            console.error('Simplestream::Heartbeat: Missing companyId');
            return;
        } else if(!options.contentId) {
            console.error('Simplestream::Heartbeat: Missing contentId');
            return;
        } else if(!options.contentType) {
            console.error('Simplestream::Heartbeat: Missing contentType');
            return;
        } else if(!options.url) {
            console.error('Simplestream::Heartbeat: Missing url');
            return;
        } else if(!options.userId) {
            console.error('Simplestream::Heartbeat: Missing userId');
        }

        // Set options
        this.videoElement = options.videoElement;
        this.companyId = options.companyId;
        this.url = options.url;
        this.contentId = options.contentId;
        this.contentType = options.contentType;
        this.userId = options.userId;

        this.init();
    }

    setHeartbeat(res) {
        res.json().then((data) => {
            this.session = data.response.session_id;
            this.playerHeartbeat = true;

            const interval = setInterval(() => {
                fetch(
                    `${this.url}update_session?session_id=${this.session}&company_id=${this.companyId}&play_head=${Math.floor(this.videoElement.currentTime)}`
                )
                    .then(response => response.json())
            }, 5000);
        });
    }

    /**
     * Initialise the pause ad container and events.
     */
    init() {
        this.videoElement.addEventListener("play", async () => {
            console.log("Simplestream::Heartbeat::Event Play");

            if (!this.playerHeartbeat) {
                const userid = this.userId;

                const res = await fetch(
                    `${this.url}start_session?user_id=${userid}&company_id=${this.companyId}&content_id=${this.contentId}&content_type=${this.contentType}&platform_id=website&play_head=${Math.floor(this.videoElement.currentTime)}`
                );

                if (res.ok) {
                    this.setHeartbeat(res);
                } else {
                    console.error("Failed to start session", res);
                }
            }
        });
    }
}

export default Heartbeat;
